var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssueDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8379_40351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 15.5H21",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5H7",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5H21",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7.5H16",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5H10C10.1978 9.5 10.3911 9.55865 10.5556 9.66853C10.72 9.77841 10.8482 9.93459 10.9239 10.1173C10.9996 10.3 11.0194 10.5011 10.9808 10.6951C10.9422 10.8891 10.847 11.0673 10.7071 11.2071C10.5673 11.347 10.3891 11.4422 10.1951 11.4808C10.0011 11.5194 9.80004 11.4996 9.61732 11.4239C9.43459 11.3482 9.27841 11.22 9.16853 11.0556C9.05865 10.8911 9 10.6978 9 10.5V8C9 7.46957 9.21071 6.96086 9.58579 6.58579C9.96086 6.21071 10.4696 6 11 6",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5H4C4.19778 9.5 4.39112 9.55865 4.55557 9.66853C4.72002 9.77841 4.84819 9.93459 4.92388 10.1173C4.99957 10.3 5.01937 10.5011 4.98079 10.6951C4.9422 10.8891 4.84696 11.0673 4.70711 11.2071C4.56725 11.347 4.38907 11.4422 4.19509 11.4808C4.00111 11.5194 3.80004 11.4996 3.61732 11.4239C3.43459 11.3482 3.27841 11.22 3.16853 11.0556C3.05865 10.8911 3 10.6978 3 10.5V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8379_40351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueDetails);
export default __webpack_public_path__ + "static/media/issue-details.e875188f30aad8492c4609ca9c56ce01.svg";
export { ForwardRef as ReactComponent };